module.exports = __webpack_public_path__ + "resource/img/no-data.9cc6a071.png";